
<div
  class="h-100"
  :class="[jel_getClassObject(content), isMenuGaucheOuvert ? 'menu-ouvert' : 'menu-ferme']"
>
  <div class="border-right h-100 d-flex flex-column">
    <button class="menu-bouton py-2" @click="ouvrirFermerTiroir()">
      <b-icon icon="list"></b-icon>
      <span class="sr-only">
        {{
          isMenuGaucheOuvert
            ? $i18n.tc('messageComponent.actionMenu', 2)
            : $i18n.tc('messageComponent.actionMenu', 1)
        }}
        {{ $t('messageComponent.burgerMenu') }}
      </span>
    </button>
    <Menu :content="content">
      <template #element="{ itemElement }">
        <div class="item" :class="{ 'menu-titre': itemElement.image }">
          <div class="img-container d-flex align-items-center justify-content-center">
            <b-img-lazy
              v-if="itemElement.image"
              class="img-item"
              :src="jel_getFichierSrc(itemElement.image)"
              :alt="isMenuGaucheOuvert ? '' : itemElement.item"
            />
          </div>
          <div>
            {{ itemElement.item }}
          </div>
        </div>
      </template>
    </Menu>
  </div>
</div>
